import { type IAIReceptionistSectionQaPairs } from '@principle-theorem/principle-core/interfaces';

export enum AiKnowledgeBaseSection {
  PracticeDetails = 'practiceDetails',
  OurTeam = 'ourTeam',
  OpeningHours = 'openingHours',
  ServicesTreatments = 'servicesTreatments',
  AppointmentsPolicies = 'appointmentsPolicies',
  EmergencyAdditional = 'emergencyAdditional',
  CommonQuestions = 'common-questions',
  CustomSections = 'customSections',
  GreetingMessages = 'greetingMessages',
  CallHandlingRouting = 'callHandlingRouting',
  BookingConfiguration = 'bookingConfiguration',
  PhoneNumber = 'phoneNumber',
}

export const AI_KNOWLEDGE_BASE_SECTION_LABELS: Record<
  AiKnowledgeBaseSection,
  string
> = {
  [AiKnowledgeBaseSection.PracticeDetails]: 'Practice Details',
  [AiKnowledgeBaseSection.OurTeam]: 'Our Team',
  [AiKnowledgeBaseSection.OpeningHours]: 'Opening Hours',
  [AiKnowledgeBaseSection.ServicesTreatments]: 'Services & Treatments',
  [AiKnowledgeBaseSection.AppointmentsPolicies]: 'Appointments & Policies',
  [AiKnowledgeBaseSection.EmergencyAdditional]: 'Emergency & Additional Info',
  [AiKnowledgeBaseSection.CustomSections]: 'Custom Sections',
  [AiKnowledgeBaseSection.CommonQuestions]: 'Common Questions',
  [AiKnowledgeBaseSection.GreetingMessages]: 'Greeting & Messages',
  [AiKnowledgeBaseSection.CallHandlingRouting]: 'Call Handling & Routing',
  [AiKnowledgeBaseSection.BookingConfiguration]: 'Booking Configuration',
  [AiKnowledgeBaseSection.PhoneNumber]: 'Phone Number',
};

export const AI_KNOWLEDGE_BASE_QA_CATEGORY_LABELS: Record<
  keyof IAIReceptionistSectionQaPairs,
  string
> = {
  generalServices: 'General Services',
  cosmeticServices: 'Cosmetic Services',
  appointments: 'Appointments & Booking',
  feesPayments: 'Fees & Payments',
  parkingAccess: 'Parking & Access',
  ourTeam: 'Our Team',
};

export const AI_KNOWLEDGE_BASE_SECTION_ROUTES: Record<
  AiKnowledgeBaseSection,
  string
> = {
  [AiKnowledgeBaseSection.PracticeDetails]: 'practice-details',
  [AiKnowledgeBaseSection.OurTeam]: 'our-team',
  [AiKnowledgeBaseSection.OpeningHours]: 'opening-hours',
  [AiKnowledgeBaseSection.ServicesTreatments]: 'services-treatments',
  [AiKnowledgeBaseSection.AppointmentsPolicies]: 'appointments-policies',
  [AiKnowledgeBaseSection.EmergencyAdditional]: 'emergency-additional',
  [AiKnowledgeBaseSection.CustomSections]: 'custom-sections',
  [AiKnowledgeBaseSection.CommonQuestions]: 'common-questions',
  [AiKnowledgeBaseSection.GreetingMessages]: 'greeting-messages',
  [AiKnowledgeBaseSection.CallHandlingRouting]: 'call-handling-routing',
  [AiKnowledgeBaseSection.BookingConfiguration]: 'booking-configuration',
  [AiKnowledgeBaseSection.PhoneNumber]: 'phone-number',
};

/**
 * How long a Knowledge Base section waits after the last edit before writing
 * it to the editor store. Anything reading the store for the whole Knowledge
 * Base waits this long first, so it sees the last edit.
 */
export const AI_KNOWLEDGE_BASE_SECTION_EDIT_DEBOUNCE_MS = 300;
